var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1606.79 1372.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#bdd0fb;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:#0b1baa;}.cls-17{fill:#3640fe;}.cls-18{fill:#fff;}.cls-19{fill:#100877;}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#linear-gradient-21);}.cls-27{fill:url(#linear-gradient-22);}.cls-28{fill:url(#linear-gradient-23);}.cls-29{fill:url(#linear-gradient-24);}.cls-30{fill:url(#linear-gradient-25);}.cls-31{fill:url(#linear-gradient-26);}.cls-32{fill:url(#linear-gradient-27);}.cls-33{fill:url(#linear-gradient-28);}.cls-34{fill:#91b3fa;}.cls-35{fill:url(#linear-gradient-29);}.cls-36{fill:url(#linear-gradient-30);}.cls-37{fill:url(#linear-gradient-31);}.cls-38{fill:url(#linear-gradient-32);}.cls-39{fill:url(#linear-gradient-33);}.cls-40{fill:url(#linear-gradient-34);}.cls-41{fill:url(#linear-gradient-35);}.cls-42{fill:url(#linear-gradient-36);}.cls-43{fill:url(#linear-gradient-37);}.cls-44{fill:url(#linear-gradient-38);}.cls-45{fill:url(#linear-gradient-39);}.cls-46{fill:url(#linear-gradient-40);}.cls-47{fill:url(#linear-gradient-41);}.cls-48{fill:url(#linear-gradient-42);}.cls-49{fill:url(#linear-gradient-43);}.cls-50{fill:url(#linear-gradient-44);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2373.66,
    y1: 864.95,
    x2: 832.71,
    y2: 1263.83,
    gradientTransform: "matrix(0.29, 0.96, 0.96, -0.29, -643.97, -687.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1977.41,
    y1: 532.6,
    x2: 436.46,
    y2: 931.48,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, -883.6, 101.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1797.35,
    y1: 1118.43,
    x2: 256.4,
    y2: 1517.32,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, -495.35, -1004.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2310.75,
    y1: 836.73,
    x2: 769.78,
    y2: 1235.62,
    gradientTransform: "matrix(0.55, 0.83, 0.83, -0.55, -278.96, -766.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1792.1,
    y1: 1045.44,
    x2: 251.15,
    y2: 1444.33,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, -793.98, -666.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2099.69,
    y1: 884.41,
    x2: 558.72,
    y2: 1283.3,
    gradientTransform: "matrix(1, 0, 0, -1, -458.72, 1290.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2137.95,
    y1: 1013.98,
    x2: 596.98,
    y2: 1412.87,
    gradientTransform: "matrix(0.2, 0.98, 0.98, -0.2, 136.86, -1462.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2083.9,
    y1: 622.46,
    x2: 542.93,
    y2: 1021.35,
    gradientTransform: "matrix(1, 0, 0, -1, -458.71, 1290.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2203.05,
    y1: 1026.53,
    x2: 662.09,
    y2: 1425.42,
    gradientTransform: "matrix(1, 0, 0, -1, -458.61, 1290.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2245.19,
    y1: 1078.51,
    x2: 704.23,
    y2: 1477.39,
    gradientTransform: "matrix(0.22, 0.98, 0.98, -0.22, -317.48, -1259.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2019.93,
    y1: 925.27,
    x2: 478.97,
    y2: 1324.15,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, 21.69, -1190.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 2003.38,
    y1: 777.61,
    x2: 462.41,
    y2: 1176.5,
    gradientTransform: "matrix(1, 0, 0, -1, -458.6, 1290.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1977.5,
    y1: 641.41,
    x2: 436.55,
    y2: 1040.3,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, -854.97, -83.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 2223.17,
    y1: 752.92,
    x2: 682.21,
    y2: 1151.8,
    gradientTransform: "matrix(0.23, 0.97, 0.97, -0.23, -416.55, -679.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 935.6,
    y1: -208.04,
    x2: 938.66,
    y2: -116.25,
    gradientTransform: "matrix(1, 0, 0, -1, -470.05, 1330.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1045.61,
    y1: 26.82,
    x2: 856.52,
    y2: -121.65,
    gradientTransform: "matrix(1, 0, 0, -1, -470.05, 1330.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 3587.59,
    y1: 24.56,
    x2: 3577.33,
    y2: -65.01,
    gradientTransform: "translate(4049.45 1330.37) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 3761.79,
    y1: -17.21,
    x2: 3578.93,
    y2: -160.78,
    gradientTransform: "translate(4049.45 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 3709.07,
    y1: -264.78,
    x2: 3712.13,
    y2: -173.01,
    gradientTransform: "translate(4049.45 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 3695.67,
    y1: 13.11,
    x2: 3686.07,
    y2: -70.68,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1824.55,
    y1: 15.79,
    x2: 1836.07,
    y2: 376.66,
    gradientTransform: "translate(2237.61 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 851.79,
    y1: 654.67,
    x2: 859.66,
    y2: 546.82,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1794.23,
    y1: 357.54,
    x2: 1712.33,
    y2: 287.58,
    gradientTransform: "translate(2237.61 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -8267.12,
    y1: 801.09,
    x2: -8297.2,
    y2: 769.31,
    gradientTransform: "matrix(0.96, 0.29, 0.37, -1.22, 7907.21, 4108.75)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 657.72,
    y1: 608.56,
    x2: 661.1,
    y2: 553.57,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 892.96,
    y1: 667.34,
    x2: 787.34,
    y2: 613.42,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2244.06,
    y1: 4566.18,
    x2: -2152.35,
    y2: 4566.18,
    gradientTransform: "matrix(-0.99, -0.16, 0.16, -0.99, -2495.18, 4866.99)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2286.96,
    y1: 4510.52,
    x2: -2226.66,
    y2: 4572.38,
    gradientTransform: "matrix(-0.99, -0.16, 0.16, -0.99, -2495.18, 4866.99)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1593.47,
    y1: 305.44,
    x2: 1697.95,
    y2: 620.01,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 831.65,
    y1: 552.37,
    x2: 724.22,
    y2: 420.3,
    gradientTransform: "translate(2161.3 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1058.3,
    y1: 594.95,
    x2: 911.34,
    y2: 414.27,
    gradientTransform: "translate(2161.3 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 7363.57,
    y1: -221.34,
    x2: 7359.99,
    y2: -661.06,
    gradientTransform: "matrix(0.99, -0.12, -0.12, -0.99, -5977.18, 2019.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 1738.24,
    y1: 553.49,
    x2: 1707.9,
    y2: 447.88,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1729.16,
    y1: 638.26,
    x2: 1735.9,
    y2: 530.41,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1617.76,
    y1: 297.37,
    x2: 1722.24,
    y2: 611.94,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -8672.8,
    y1: 233.54,
    x2: -8666.06,
    y2: 125.69,
    gradientTransform: "translate(-7355.48 386.47) rotate(-179.43)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 1734.75,
    y1: 85.15,
    x2: 1750.47,
    y2: -88.99,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 7198.39,
    y1: -54.66,
    x2: 7248.79,
    y2: -54.66,
    gradientTransform: "matrix(1, -0.01, -0.01, -1, -5970.09, 1386.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1761.67,
    y1: 195.49,
    x2: 1712.24,
    y2: 0.01,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 7245.12,
    y1: -63.75,
    x2: 7305.19,
    y2: -63.75,
    gradientTransform: "matrix(1, -0.01, -0.01, -1, -5970.09, 1386.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1751.75,
    y1: 142.47,
    x2: 1700.07,
    y2: 319.97,
    gradientTransform: "matrix(1, 0, 0, -1, -426.94, 1330.37)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 718.59,
    y1: 509.65,
    x2: 721.93,
    y2: 430.33,
    gradientTransform: "translate(2161.3 1330.37) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 754.59,
    y1: 572.32,
    x2: 685.37,
    y2: 487.24,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 716.73,
    y1: 536.96,
    x2: 684.33,
    y2: 497.12,
    gradientTransform: "translate(2161.3 1330.37) rotate(180)",
    xlinkHref: "#linear-gradient-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 824.62,
    cy: 174.87,
    r: 64.66,
    transform: "translate(386.5 873.88) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 760.12,
    y: 110.89,
    width: 16.6,
    height: 54.23,
    rx: 3.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M845.92,150.41H835v-13c0-4.18-2.21-6.94-6.39-6.94h-.27a7.32,7.32,0,0,0-7.58,7v.22l-3.61,12.92c-1.67,0-4.29,1.19-4.29,2.87V203c0,1.68,3.89,3.83,5.55,3.83h27.49c6.26,0,11.23-5.87,11.23-12.13V161.84a11.32,11.32,0,0,0-11.22-11.43Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 120.76,
    cy: 427.68,
    r: 41.57,
    transform: "translate(-354.95 407.45) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.04,
    y: 372.51,
    width: 10.67,
    height: 34.86,
    rx: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.53,412h-7v-8.34c0-2.69-1.43-4.47-4.12-4.47h-.17a4.71,4.71,0,0,0-4.87,4.54v.13l-2.33,8.3c-1.07,0-2.75.76-2.75,1.84v31.85c0,1.08,2.49,2.45,3.57,2.45h17.66c4,0,7.22-3.77,7.22-7.8V419.38a7.28,7.28,0,0,0-7.22-7.35Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1013.96,
    cy: 119.73,
    r: 41.57,
    transform: "translate(632.78 1039.56) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 961.28,
    y: 64.55,
    width: 10.67,
    height: 34.86,
    rx: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1027.77,104.06h-7V95.72c0-2.69-1.42-4.47-4.11-4.47h-.17a4.71,4.71,0,0,0-4.87,4.55v.12l-2.33,8.3c-1.07,0-2.75.78-2.75,1.85v31.82c0,1.07,2.49,2.45,3.57,2.45h17.67c4,0,7.21-3.77,7.21-7.8V111.41a7.28,7.28,0,0,0-7.21-7.35Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1596.94,
    cy: 419.3,
    r: 41.57,
    transform: "translate(334.87 1480.83) rotate(-56.54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1544.1,
    y: 364.03,
    width: 10.67,
    height: 34.86,
    rx: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1610.6,403.55h-7v-8.34c0-2.69-1.41-4.46-4.1-4.46h-.17a4.71,4.71,0,0,0-4.87,4.54.53.53,0,0,0,0,.13l-2.32,8.3c-1.08,0-2.75.76-2.75,1.83v31.82c0,1.08,2.49,2.46,3.56,2.46h17.68c4,0,7.22-3.78,7.22-7.8V410.91a7.29,7.29,0,0,0-7.22-7.36Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 651.05,
    cy: 100.12,
    r: 41.57,
    transform: "translate(372.32 671.24) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 598.35,
    y: 44.93,
    width: 10.67,
    height: 34.86,
    rx: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M664.85,84.45h-7V76.11c0-2.69-1.42-4.47-4.11-4.47h-.17a4.71,4.71,0,0,0-4.87,4.54v.13l-2.34,8.3c-1.07,0-2.75.77-2.75,1.84v31.83c0,1.07,2.49,2.45,3.56,2.45h17.68c4,0,7.22-3.83,7.22-7.8V91.8a7.27,7.27,0,0,0-7.21-7.35Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 382.46,
    cy: 80.69,
    r: 52.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.74,105.61c-5.75-5.59-14.57-3.9-20.69,1.23a2.4,2.4,0,0,1-3,0c-6.2-5-15.06-6.55-20.65-.86a15.67,15.67,0,0,0,.17,22.17l0,0,20.67,20.32a2.4,2.4,0,0,0,3.38,0l20.32-20.68A15.7,15.7,0,0,0,436.74,105.61Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1569.86,
    cy: 279.91,
    r: 52.46,
    transform: "translate(946.21 1721.09) rotate(-78.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1592.42,265.33c-5.69-5.6-14.57-3.91-20.68,1.22a2.38,2.38,0,0,1-3,0c-6.19-5-15.06-6.55-20.65-.85a15.68,15.68,0,0,0,.17,22.16l0,0,20.68,20.32a2.37,2.37,0,0,0,3.36,0h0l20.32-20.68a15.69,15.69,0,0,0-.19-22.19Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 40.2,
    cy: 258.11,
    r: 40.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.19,286.46c-4.35-4.29-11.16-3-15.84,1a1.83,1.83,0,0,1-2.33,0c-4.78-3.83-11.54-5-15.82-.66a12,12,0,0,0,.13,17h0l15.85,15.57a1.81,1.81,0,0,0,2.58,0l15.57-15.84a12,12,0,0,0-.12-17Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1354.11,
    cy: 163.24,
    r: 40.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1403,191.55c-4.37-4.29-11.18-3-15.86.95a1.81,1.81,0,0,1-2.32,0c-4.79-3.83-11.49-5-15.83-.65a12,12,0,0,0,.15,17h0L1385,224.42a1.83,1.83,0,0,0,2.58,0l15.58-15.84a12,12,0,0,0-.13-17Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1247.6,
    cy: 104.19,
    r: 64.66,
    transform: "translate(839.32 1258.65) rotate(-77.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1265.85,83.08c0,10-8.11,20.81-18.11,20.81s-18.12-10.81-18.12-20.81S1237.72,66,1247.74,66,1265.85,73.09,1265.85,83.08Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1225.25,142.43h44.23a10.69,10.69,0,0,0,10.19-7.45l2.39-7.44a10.7,10.7,0,0,0-6.47-13.3c-18-6.58-36.61-5.75-55.67.61a10.66,10.66,0,0,0-6.84,12.92l1.84,6.75A10.7,10.7,0,0,0,1225.25,142.43Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 1397.58,
    cy: 354.41,
    r: 52.84,
    transform: "translate(694.08 1590.66) rotate(-76.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1412.34,337.09c0,8.18-6.62,17-14.8,17s-14.81-8.82-14.81-17,6.64-14,14.81-14S1412.34,328.92,1412.34,337.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1379.16,385.58h36.15a8.77,8.77,0,0,0,8.33-6.08l1.91-6.08a8.75,8.75,0,0,0-5.27-10.88c-14.72-5.38-29.92-4.69-45.5.5a8.7,8.7,0,0,0-5.58,10.53l1.49,5.52A8.76,8.76,0,0,0,1379.16,385.58Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 200.38,
    cy: 165.22,
    r: 54.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.56,186.74c0,8.51-6.9,17.7-15.41,17.7s-15.4-9.19-15.4-17.7,6.89-14.54,15.4-14.54S247.56,178.24,247.56,186.74Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213,237.2h37.61a9.11,9.11,0,0,0,8.62-6.33l2-6.33a9.09,9.09,0,0,0-5.48-11.27c-15.31-5.6-31.13-4.88-47.34.51a9.06,9.06,0,0,0-5.78,11l1.56,5.75A9.1,9.1,0,0,0,213,237.2Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 252.39,
    cy: 352.93,
    r: 35.74,
    transform: "translate(-180.81 477.99) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M262.52,341.29c0,5.54-4.49,11.49-10,11.49s-10-6-10-11.49,4.49-9.46,10-9.46S262.52,335.8,262.52,341.29Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240,374.09h24.45a5.94,5.94,0,0,0,5.64-4.12l1.31-4.1a5.94,5.94,0,0,0-3.57-7.37c-9.95-3.63-20.24-3.16-30.78.34a5.89,5.89,0,0,0-3.77,7.15l1,3.73A5.92,5.92,0,0,0,240,374.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 847.99,
    cy: 332.03,
    r: 35.47,
    transform: "translate(298.31 1041.56) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M858,320.48c0,5.49-4.44,11.41-9.93,11.41s-9.94-5.92-9.94-11.41,4.45-9.38,9.94-9.38S858,315,858,320.48Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M835.76,353H860A5.86,5.86,0,0,0,865.6,349l1.32-4.09a5.86,5.86,0,0,0-3.55-7.29c-9.87-3.61-20.1-3.15-30.53.33a5.85,5.85,0,0,0-3.75,7.09l1,3.7A5.88,5.88,0,0,0,835.76,353Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1232.8,991.83c.26,122.62-33.87,217.8-103.15,285.27S960.71,1378.49,830,1378.77q-191.62.42-294.71-97.39T431.76,999.29l-.83-391.45h254.7l.79,371q.23,99.36,37.34,144.28t109.57,44.71q77.53-.17,112.3-44.76c23.22-29.67,34.65-78.65,34.46-146.16l-.78-369.12h252.63Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1232.84,988.39c.26,117.27-33.9,208.35-103.19,272.82s-168.94,97-299.68,97.28q-191.62.42-294.7-93.12C466.58,1203,432,1112.84,431.79,995.56L431,609H685.63l.78,367.08c.14,63.34,12.5,109.47,37.34,138s61.26,42.87,109.55,42.76q77.54-.16,112.32-42.81c23.22-28.44,34.64-75.27,34.47-139.84L979.3,609h252.63Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M678,429.34l-239.9.51c-4.14,0-7.48,2.93-7.47,7L431,616.79l254.64-.51-.38-179.88a7,7,0,0,0-6.9-7.06Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1224.65,428.17l-238.44.48a6.88,6.88,0,0,0-7.18,6.57c0,.16,0,.33,0,.49l.39,179.87,252.64-.54-.38-179.88a6.72,6.72,0,0,0-6.4-7Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M466.71,1015.23c-1.91,0-4.11-1.58-4.12-3.55l-.76-360.21c0-1.92,2.13-3.56,4.1-3.56s4.11,1.58,4.11,3.55l.77,360.21C470.82,1013.63,468.67,1015.23,466.71,1015.23Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1067.37,1283.13a3.56,3.56,0,0,1-1.39-6.84c81.59-34.1,115.17-125.67,129-196.48,15.06-77.21,10.53-147.09,10.53-147.79a3.56,3.56,0,0,1,7.11-.48c0,.7,4.63,71.52-10.6,149.63-9,45.95-23,85.53-41.56,117.51-23.42,40.21-54.25,68.54-91.65,84.17A3.62,3.62,0,0,1,1067.37,1283.13Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "539.18 137.69 488.29 237.3 526.97 237.3 513.73 312.22 592.79 212.87 540.54 208.56 539.18 137.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "689.15 195.7 620.13 254.79 649.24 266.74 616.07 319.14 706.23 268.89 668.26 249.47 689.15 195.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "354.3 205.37 371.85 294.51 396.56 275.04 425.9 329.69 426.44 226.46 390.87 249.98 354.3 205.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1086.36 137.69 1035.47 237.3 1074.16 237.3 1060.92 312.22 1139.98 212.87 1087.73 208.56 1086.36 137.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "1228.69 196.65 1159.66 255.75 1188.77 267.7 1155.59 320.09 1245.76 269.85 1207.79 250.42 1228.69 196.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "901.49 205.37 919.04 294.51 943.76 275.04 973.09 329.69 973.63 226.46 938.06 249.98 901.49 205.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M335.54,525.69H169.05a27.12,27.12,0,0,0-27.15,27.09v42.75A27.11,27.11,0,0,0,169,622.64h51.42a3.28,3.28,0,0,1,3,1.92l21.31,47.3a2.94,2.94,0,0,0,3.89,1.46A2.91,2.91,0,0,0,250,672l25.54-47.67a3.32,3.32,0,0,1,2.88-1.74h57.08a27.12,27.12,0,0,0,27.12-27.11v-42.7A27.13,27.13,0,0,0,335.54,525.69Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M235.71,556.07h-.16L226,560.92l-1.76-7.52L237,547.09h8.29v52.56h-9.57Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M263.47,599.65v-6.07l6.22-5.74c12.38-11.49,18.19-17.8,18.28-24.75,0-4.69-2.51-8.81-9.38-8.81-4.61,0-8.62,2.34-11.24,4.36l-2.87-7a25.94,25.94,0,0,1,16.17-5.41c11.65,0,17.3,7.36,17.3,15.93,0,9.21-6.63,16.66-15.76,25.14l-4.62,4v.16h21.51v8.25Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M340.15,555.34H320l-1.53,10.53a27.26,27.26,0,0,1,3.83-.24A23.35,23.35,0,0,1,335,569c4,2.51,6.87,7,6.87,13.34,0,10-8.33,18.19-21.26,18.19a30.33,30.33,0,0,1-13.91-3.07l2-7.53a26.53,26.53,0,0,0,11.57,2.75c5.82,0,11.4-3.31,11.4-9.62,0-6-4.45-10-15-10a46.58,46.58,0,0,0-7.18.49L313,547.1h27.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M197.58,557.26c0,6.92-5.61,14.36-12.52,14.36s-12.53-7.47-12.53-14.36,5.61-11.82,12.53-11.82S197.58,550.35,197.58,557.26Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M169.51,598.3h30.58a7.41,7.41,0,0,0,7.06-5.15l1.64-5.14a7.39,7.39,0,0,0-4.47-9.21c-12.44-4.55-25.32-4-38.5.42a7.39,7.39,0,0,0-4.73,8.94l1.28,4.67A7.39,7.39,0,0,0,169.51,598.3Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M337.9,777.58s-31.21,29.59-41.52,82.19-34.82-74.36-34.82-74.36H236.82s-9.34,130.82,60.55,141.22a37.51,37.51,0,0,0,35-13.87c12.76-16.2,32.67-45,37.48-72.51C365.75,796.93,337.9,777.58,337.9,777.58Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M496.44,1383.35a4.68,4.68,0,0,0-.12-1.18c-5.85-23.2-29.79-35.1-29.79-35.1L455,1348c-6.61,20.44-10.88,30.44-9.82,36a3.45,3.45,0,0,0,.12.46A272.66,272.66,0,0,0,496.44,1383.35Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M446.31,1384.46a5,5,0,0,0,3.65,3.68c13.51,2.88,35,.56,44-.62a4.19,4.19,0,0,0,3.49-4.17A273.43,273.43,0,0,1,446.31,1384.46Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M476,1329.16l-5.05,24.26a4,4,0,0,1-3.39,3.27,33.45,33.45,0,0,1-7.81-.13,5,5,0,0,1-3.95-5.85h0l3.5-21.54Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M347.48,1384.26c12.3-.35,18.66-1.79,21.95-3.14v3.76a2.43,2.43,0,0,1-2.31,2.47l-67.56-.47c-2.15,0-3.42-2.51-2.48-4.49C305.93,1383.16,328.48,1384.79,347.48,1384.26Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M297.08,1382.42a2.49,2.49,0,0,1,.27-.51c5.95-8.33,21.15-24.89,51.16-32.11l14.36-.45s6.41,11.13,6.53,31.77c-3.29,1.35-9.65,2.79-21.95,3.14C328.48,1384.79,305.93,1383.16,297.08,1382.42Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M365.57,1327.53c-.16,1.07-2.14,17.37-2.88,23.7a3.12,3.12,0,0,1-2.64,2.87,32.8,32.8,0,0,1-9.89-.14,4.26,4.26,0,0,1-3.22-4.28v-25.6Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M466.41,1010.49s23,204.76,10.24,332.74c0,0-15.32,0-23-2.56,0,0-23.93-200.2-31.68-257.5a1.92,1.92,0,1,0-3.83-.13c-9.57,48.2-47.08,237.21-51.54,255.06,0,0-12.8,5.12-23,0,0,0,20.47-273.87,35.83-322.5Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M512.46,772.46s-97.26-15.32-174,5.12l5.12,79.34S364,967,379.37,1015.61c0,0,58.86,10.24,87-5.12,0,0,23-138.21,35.84-158.68C502.23,851.77,515,798.05,512.46,772.46Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M444.21,688.93,454.58,768s-27.06,12.45-46-.53l4.08-46.25Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M512.46,772.46s151,163.81-26.87,226.52v-12.8s66.55-56.31,15.31-133.06C500.94,853.08,507.35,780.13,512.46,772.46Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M484.31,987.46s-23-15.32-33.28-10.24S440.8,990,440.8,990s5.12,10.24,12.8,7.65,25.59,2.57,33.27,0C486.87,997.69,489.39,987.46,484.31,987.46Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M235.29,702.67l32.55,10.94c3.93,1.19,6.64,5.16,7,10.21L273,778.06c.53,8.48-6.48,16-13.09,14l-26-8.87c-2.53-.77-4.22-3.43-4.25-6.7l-.57-67.53C229.07,705,232.28,701.76,235.29,702.67Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M229.1,772.46s-10.17-32.55-5-38.07,15.47-20.63,16.16-8.26S247.2,792,229.1,772.46Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M378.34,667.64c-.15,1,12.13,66.77,12.13,66.77l37.41-7.81-2.38-64.07S381.06,650.91,378.34,667.64Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M414.33,673a5.5,5.5,0,0,1,2.61,4.08l3.83,33.14a5.38,5.38,0,0,1,0,1.5c-.46,2.76-2.63,11.4-11.49,8.73-7.56-2.28-14.55-4.27-19.69-3.36a5.5,5.5,0,0,0-4.39,6.41v0a205,205,0,0,0,7.66,29.26,5.46,5.46,0,0,0,6.6,3.37c7.25-2,21.28-6.36,32-12.45a5.5,5.5,0,0,0,2.78-4.91c-.23-8.92-.75-33.92.19-41,.87-6.58,8.82-10.46,12.6-12a5.51,5.51,0,0,0,3.13-3.13c1.68-4.3,3.54-13.25-7.66-17.36a5.52,5.52,0,0,1-3.21-7c1.74-5,2.22-12.26-6.81-16.49s-16.18.12-20.23,4.1a5.75,5.75,0,0,1-6.77,1,3.63,3.63,0,0,0-3.61,0,5.31,5.31,0,0,1-7.18-2.23.93.93,0,0,1-.05-.1c-2.3-4.62-6.91-9.39-16.05-8-16.75,2.57-18.94,21.06-14.72,32s22.23,7.09,31.31,1.77C401.88,666.45,410.33,670.53,414.33,673Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M433.87,708.88s-4.79-18.18,2.38-22.8,17.55-2,15,11.92C448.15,715.28,433.87,708.88,433.87,708.88Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M368.09,665.94a.46.46,0,0,1-.42-.27c-5.74-12.18,7.6-21.93,7.74-22a.47.47,0,0,1,.64.17.49.49,0,0,1-.1.58c-.12.1-12.8,9.39-7.44,20.88a.46.46,0,0,1-.22.62A.34.34,0,0,1,368.09,665.94Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1437.14,1133.71l3.44-4.48a2.88,2.88,0,0,0-.46-4,2.71,2.71,0,0,0-3.82.4l-.07.08h0v.06l-3.29,4.4v.06a2.86,2.86,0,0,0,.5,3.94A2.66,2.66,0,0,0,1437.14,1133.71Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1448.14,1118.44l3.06-4.78a3,3,0,0,0-.82-4.09,2.8,2.8,0,0,0-3.9.76l0,.07h0v.06l-2.93,4.67v.07a3,3,0,0,0,.84,4A2.78,2.78,0,0,0,1448.14,1118.44Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1457.87,1102.28l2.66-5a3.08,3.08,0,0,0-1.17-4.13,2.86,2.86,0,0,0-3.92,1l-.09.16h0v.07l-2.55,4.9v.06a3.07,3.07,0,0,0,1.2,4.08A2.87,2.87,0,0,0,1457.87,1102.28Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1466.29,1085.34l2.27-5.21A3.17,3.17,0,0,0,1467,1076a3,3,0,0,0-4,1.48,1,1,0,0,0,0,.1h0v.07l-2.16,5.09v.06a3.13,3.13,0,0,0,1.56,4.1A3,3,0,0,0,1466.29,1085.34Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1473.39,1067.81l1.91-5.36a3.26,3.26,0,0,0-1.91-4.15,3.13,3.13,0,0,0-4,1.87v0h0v.07l-1.78,5.25v.07a3.24,3.24,0,0,0,1.92,4.09A3.1,3.1,0,0,0,1473.39,1067.81Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1479.21,1049.76l1.48-5.5a3.35,3.35,0,0,0-2.26-4.11,3.23,3.23,0,0,0-4,2.27.14.14,0,0,0,0,.06h0v.07l-1.39,5.38v.07a3.32,3.32,0,0,0,2.28,4A3.2,3.2,0,0,0,1479.21,1049.76Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1483.65,1031.32l1.1-5.59a3.45,3.45,0,0,0-2.62-4.06,3.36,3.36,0,0,0-3.93,2.66v.15l-1,5.45v.08a3.4,3.4,0,0,0,2.63,4A3.33,3.33,0,0,0,1483.65,1031.32Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1486.86,1012.59l.71-5.66a3.53,3.53,0,0,0-3-4,3.46,3.46,0,0,0-3.83,3.06v.11l-.65,5.52v.07a3.48,3.48,0,0,0,3,3.9A3.44,3.44,0,0,0,1486.86,1012.59Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1488.78,993.69l.34-5.68a3.53,3.53,0,1,0-7-.46h0v.11l-.28,5.55v.08a3.51,3.51,0,1,0,7,.4h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1489.51,974.7V969a3.64,3.64,0,0,0-7.27-.38,2.41,2.41,0,0,0,0,.38v.1l.08,5.56v.08a3.61,3.61,0,0,0,7.21.3v-.37Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1489,955.69l-.38-5.69a3.73,3.73,0,1,0-7.44.52v.11l.43,5.55v.07a3.73,3.73,0,0,0,3.95,3.5h0A3.83,3.83,0,0,0,1489,955.69Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1487.35,936.75l-.73-5.65a3.81,3.81,0,0,0-4.21-3.4h-.08a3.91,3.91,0,0,0-3.29,4.42v.11l.77,5.51v.07a3.83,3.83,0,0,0,4.27,3.32h0A3.91,3.91,0,0,0,1487.35,936.75Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1484.52,918l-1.08-5.61a3.92,3.92,0,0,0-4.54-3.17h-.06a4,4,0,0,0-3.06,4.74h0V914l1.08,5.45v.07a3.91,3.91,0,0,0,4.55,3.13h0A4,4,0,0,0,1484.52,918Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1480.51,899.37l-1.43-5.51a3.93,3.93,0,0,0-4.76-2.88h0a4.07,4.07,0,0,0-2.82,5h0v.08l1.42,5.36v.07a3.92,3.92,0,0,0,4.72,2.89l.06,0A4.08,4.08,0,0,0,1480.51,899.37Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1475.38,881.1l-1.76-5.42a4,4,0,0,0-5-2.64l-.12,0a4.16,4.16,0,0,0-2.53,5.22h0v.08l1.74,5.25v.08a4,4,0,0,0,5,2.6l.1,0A4.15,4.15,0,0,0,1475.38,881.1Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1469.12,863.19l-2.1-5.3a4,4,0,0,0-5.19-2.33l-.1.05a4.22,4.22,0,0,0-2.22,5.44h0v.08l2,5.13v.07a4,4,0,0,0,5.19,2.3l.1,0A4.22,4.22,0,0,0,1469.12,863.19Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1461.75,845.72l-2.43-5.15a4.06,4.06,0,0,0-5.39-2l-.1,0a4.3,4.3,0,0,0-1.92,5.66h0v.08l2.39,5v.08a4.05,4.05,0,0,0,5.38,2l.1,0A4.28,4.28,0,0,0,1461.75,845.72Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1453.28,828.79l-2.75-5a4.09,4.09,0,0,0-5.53-1.68l-.15.09a4.34,4.34,0,0,0-1.54,5.84h0v.08l2.7,4.79V833a4.07,4.07,0,0,0,5.54,1.63.47.47,0,0,0,.12-.07A4.33,4.33,0,0,0,1453.28,828.79Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1443.72,812.44l-3.07-4.78a4.13,4.13,0,0,0-5.71-1.3l-.13.09a4.41,4.41,0,0,0-1.17,6h0v.08l3,4.59,0,.08a4.12,4.12,0,0,0,5.69,1.26l.13-.09A4.4,4.4,0,0,0,1443.72,812.44Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1433.1,796.83l-3.36-4.53a4.16,4.16,0,0,0-5.82-.93l-.15.11a4.47,4.47,0,0,0-.79,6.15h0v.06l3.29,4.38v.07a4.17,4.17,0,0,0,5.82.89l.13-.1A4.47,4.47,0,0,0,1433.1,796.83Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1421.57,782l-3.64-4.31a4.21,4.21,0,0,0-5.94-.56l-.14.11a4.54,4.54,0,0,0-.43,6.27h0v0l3.55,4.18v.06a4.21,4.21,0,0,0,5.94.52l.12-.1A4.53,4.53,0,0,0,1421.57,782Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1409.17,767.84l-3.83-4.08a4.27,4.27,0,0,0-6-.2l-.13.13a4.6,4.6,0,0,0-.08,6.35h0l.06.06,3.83,3.95v.05a4.25,4.25,0,0,0,6,.14l.13-.14A4.58,4.58,0,0,0,1409.17,767.84Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1396,754.52l-4.1-3.83a4.32,4.32,0,0,0-6.11.18l-.12.12a4.67,4.67,0,0,0,.3,6.43h0l.06.06,4,3.71h.06a4.29,4.29,0,0,0,6.08-.2.86.86,0,0,0,.13-.14A4.62,4.62,0,0,0,1396,754.52Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1382.08,742l-4.31-3.6a4.36,4.36,0,0,0-6.15.52l-.12.15a4.7,4.7,0,0,0,.65,6.47h0l.06.05,4.2,3.47h.06a4.37,4.37,0,0,0,6.14-.55l.11-.15A4.67,4.67,0,0,0,1382.08,742Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1367.51,730.3,1363,727a4.43,4.43,0,0,0-6.2.91l-.1.13a4.78,4.78,0,0,0,1,6.49h.06l4.38,3.24h.07a4.4,4.4,0,0,0,6.16-.92l.11-.15A4.74,4.74,0,0,0,1367.51,730.3Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1352.36,719.44l-4.65-3.1a4.48,4.48,0,0,0-6.22,1.21,1.37,1.37,0,0,0-.13.2,4.78,4.78,0,0,0,1.36,6.5h.06l4.55,3h.06a4.47,4.47,0,0,0,6.18-1.27l.1-.16A4.8,4.8,0,0,0,1352.36,719.44Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1336.67,709.42l-4.79-2.87a4.54,4.54,0,0,0-6.22,1.62l-.08.13a4.84,4.84,0,0,0,1.71,6.49h0l4.7,2.74h.06a4.52,4.52,0,0,0,6.18-1.64,1.09,1.09,0,0,0,.08-.15A4.78,4.78,0,0,0,1336.67,709.42Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1320.49,700.27l-4.94-2.58a4.59,4.59,0,0,0-6.17,2l-.06.12a4.86,4.86,0,0,0,2,6.42h.06l4.79,2.51h.07a4.57,4.57,0,0,0,6.16-2l.06-.12A4.84,4.84,0,0,0,1320.49,700.27Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1303.88,692l-5.05-2.32a4.58,4.58,0,0,0-6.06,2.27,1,1,0,0,0-.07.15,4.85,4.85,0,0,0,2.35,6.32h0l4.94,2.26h.06a4.59,4.59,0,0,0,6.07-2.29l.06-.14A4.78,4.78,0,0,0,1303.88,692Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1286.91,684.55l-5.15-2.07a4.63,4.63,0,0,0-6,2.63s0,.07,0,.11a4.83,4.83,0,0,0,2.65,6.2h.06l5,2h.07a4.59,4.59,0,0,0,6-2.61.61.61,0,0,0,0-.12A4.79,4.79,0,0,0,1286.91,684.55Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1269.62,678l-5.24-1.81a4.64,4.64,0,0,0-5.88,2.93l0,.1a4.85,4.85,0,0,0,2.94,6.09h.06l5.13,1.76h.05a4.65,4.65,0,0,0,5.88-2.93l0-.1A4.8,4.8,0,0,0,1269.62,678Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1252.05,672.21l-5.33-1.56a4.66,4.66,0,0,0-5.72,3.24l0,.07a4.78,4.78,0,0,0,3.22,6h.06l5.2,1.52h.06a4.65,4.65,0,0,0,5.72-3.25l0-.07A4.79,4.79,0,0,0,1252.05,672.21Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1234.24,667.3l-5.4-1.3a4.68,4.68,0,0,0-5.62,3.5.29.29,0,0,1,0,.09,4.85,4.85,0,0,0,3.5,5.81h.06l5.27,1.27h.06a4.69,4.69,0,0,0,5.62-3.52s0,0,0-.08A4.82,4.82,0,0,0,1234.24,667.3Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1216.22,663.23l-5.43-1.05a4.71,4.71,0,0,0-5.48,3.79v0a4.84,4.84,0,0,0,3.75,5.66h.06l5.31,1h.07a4.71,4.71,0,0,0,5.47-3.8v0A4.8,4.8,0,0,0,1216.22,663.23Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1198.06,660l-5.48-.81a4.85,4.85,0,0,0-1.32,9.61h.07l5.35.78h0a4.84,4.84,0,0,0,1.33-9.58Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1179.77,657.64l-5.5-.54a4.86,4.86,0,0,0-.94,9.67h.09l5.38.53h.07a4.85,4.85,0,0,0,.91-9.66Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1161.39,656.12l-5.53-.29a4.88,4.88,0,1,0-.48,9.74h.08l5.4.28h.06a4.87,4.87,0,0,0,.47-9.73Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1143,655.46h-5.54a4.89,4.89,0,0,0,0,9.77H1143a4.88,4.88,0,1,0,0-9.76Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1124.54,655.65l-5.53.21a4.9,4.9,0,0,0,.36,9.79h.06l5.4-.21h.06a4.9,4.9,0,0,0-.35-9.78Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1106.15,656.64l-5.52.44a4.85,4.85,0,0,0-4.37,5.27,4.79,4.79,0,0,0,5,4.52h.14l5.4-.44h.05a4.86,4.86,0,0,0,4.37-5.27,4.8,4.8,0,0,0-5-4.52Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1087.82,658.4l-5.49.66a4.88,4.88,0,0,0-4.18,5.46,4.78,4.78,0,0,0,5.21,4.32h.15l5.37-.66h.06a4.89,4.89,0,0,0,4.17-5.45,4.78,4.78,0,0,0-5.21-4.33Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1069.57,660.86l-5.46.88a4.91,4.91,0,0,0-4,5.64,4.79,4.79,0,0,0,5.38,4.11l.09,0h.06l5.35-.87h0a4.9,4.9,0,0,0,4-5.64,4.78,4.78,0,0,0-5.37-4.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1051.43,664.05l-5.42,1.09a4.94,4.94,0,0,0-3.83,5.8,4.79,4.79,0,0,0,5.52,3.91l.11,0h.06l5.35-1.12h.06a4.91,4.91,0,0,0,3.77-5.74,4.79,4.79,0,0,0-5.5-4Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1033.42,668l-5.37,1.29a5,5,0,0,0-3.59,6,4.79,4.79,0,0,0,5.66,3.71l.09,0h0l5.27-1.27h0a5,5,0,0,0,3.58-6A4.79,4.79,0,0,0,1033.42,668Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1015.57,672.47l-5.32,1.48a5,5,0,0,0-3.39,6.09,4.79,4.79,0,0,0,5.78,3.53l.13,0h.05l5.23-1.47h0a5,5,0,0,0,3.38-6.09,4.78,4.78,0,0,0-5.77-3.53Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M997.89,677.64l-5.27,1.67a5,5,0,0,0-3.2,6.22,4.78,4.78,0,0,0,5.89,3.33l.15,0h0l5.18-1.65h.05a5,5,0,0,0,3.17-6.21,4.78,4.78,0,0,0-5.88-3.35Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M980.38,683.42l-5.21,1.85a5,5,0,0,0-3,6.33,4.78,4.78,0,0,0,6,3.14l.15,0h0l5.14-1.82h0a5,5,0,0,0,3-6.33,4.78,4.78,0,0,0-6-3.14Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M963.08,689.79l-5.15,2a5,5,0,0,0-2.78,6.42,4.78,4.78,0,0,0,6.11,2.91l.11,0h0l5.07-2h0a5,5,0,0,0,2.82-6.42,4.78,4.78,0,0,0-6.11-2.92l-.12,0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M946,696.69l-5.08,2.18a5,5,0,0,0-2.58,6.47,4.78,4.78,0,0,0,6.21,2.69l.07,0h0l5-2.13h0a5,5,0,0,0,2.61-6.47,4.78,4.78,0,0,0-6.2-2.72Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M929.13,704.18l-5,2.35a5,5,0,0,0-2.37,6.51,4.72,4.72,0,0,0,6.18,2.51l.14-.06h0l5-2.29h0a5,5,0,0,0,2.4-6.52,4.72,4.72,0,0,0-6.18-2.53l-.14.06Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M912.5,712.16l-5,2.49a5,5,0,0,0-2.19,6.54,4.69,4.69,0,0,0,6.23,2.31l.13-.06h0l4.89-2.44h0a5,5,0,0,0,2.2-6.54,4.68,4.68,0,0,0-6.19-2.35l-.16.08Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M896.07,720.62l-4.89,2.63a4.94,4.94,0,0,0-2,6.57,4.67,4.67,0,0,0,6.23,2.14l.15-.08h0l4.78-2.58h0a4.94,4.94,0,0,0,2-6.57,4.66,4.66,0,0,0-6.23-2.16l-.15.08Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M879.88,729.52l-4.79,2.77a4.93,4.93,0,0,0-1.82,6.59,4.63,4.63,0,0,0,6.24,2,.8.8,0,0,0,.16-.08h0l4.78-2.72h0a4.91,4.91,0,0,0,1.84-6.58,4.63,4.63,0,0,0-6.24-2l-.16.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M863.93,738.89l-4.79,2.87a4.89,4.89,0,0,0-1.63,6.59,4.59,4.59,0,0,0,6.24,1.79l.16-.09h0l4.69-2.87h0a4.92,4.92,0,0,0,1.67-6.61,4.62,4.62,0,0,0-6.28-1.79l-.14.08Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M848.22,748.66l-4.66,3a4.89,4.89,0,0,0-1.48,6.61,4.58,4.58,0,0,0,6.27,1.6l.15-.09h0l4.61-3h0a4.89,4.89,0,0,0,1.5-6.6,4.59,4.59,0,0,0-6.28-1.62l-.15.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M832.77,758.84,828.18,762a4.87,4.87,0,0,0-1.31,6.61,4.55,4.55,0,0,0,6.27,1.44l.15-.1h0l4.53-3.08h0a4.88,4.88,0,0,0,1.33-6.62,4.55,4.55,0,0,0-6.27-1.45l-.15.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M817.57,769.44l-4.51,3.25a4.78,4.78,0,0,0-1.14,6.59,4.53,4.53,0,0,0,6.26,1.28l.15-.1h0l4.46-3.2h0a4.84,4.84,0,0,0,1.15-6.6,4.53,4.53,0,0,0-6.27-1.3l-.14.1Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M802.63,780.33l-4.44,3.33a4.78,4.78,0,0,0-1,6.58,4.48,4.48,0,0,0,6.24,1.14l.15-.1h0L808,788h0a4.77,4.77,0,0,0,1-6.59,4.51,4.51,0,0,0-6.27-1.15l-.14.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M787.92,791.53l-4.37,3.41a4.78,4.78,0,0,0-.88,6.57,4.47,4.47,0,0,0,6.23,1.06l.14-.1h0l4.35-3.37h0a4.79,4.79,0,0,0,.9-6.58,4.47,4.47,0,0,0-6.22-1.07l-.16.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M773.4,803l-4.33,3.47a4.79,4.79,0,0,0-.78,6.54,4.44,4.44,0,0,0,6.21.92l.15-.11h0l4.3-3.43h0a4.79,4.79,0,0,0,.81-6.55,4.44,4.44,0,0,0-6.21-.95l-.15.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M759,814.61l-4.28,3.52a4.79,4.79,0,0,0-.71,6.52,4.41,4.41,0,0,0,6.17.84l.15-.12h0l4.27-3.48h0a4.8,4.8,0,0,0,.73-6.53,4.43,4.43,0,0,0-6.2-.86l-.14.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M744.81,826.38l-4.25,3.56a4.7,4.7,0,0,0-.65,6.48,4.37,4.37,0,0,0,6.13.81l.16-.13,4.25-3.53a4.72,4.72,0,0,0,.67-6.49,4.37,4.37,0,0,0-6.14-.83l-.15.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M730.67,838.25l-4.24,3.58a4.68,4.68,0,0,0-.62,6.45,4.35,4.35,0,0,0,6.12.75l.14-.11,4.23-3.55a4.69,4.69,0,0,0,.65-6.46,4.36,4.36,0,0,0-6.12-.79l-.15.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M716.57,850.17l-4.22,3.58a4.64,4.64,0,0,0-.62,6.41,4.33,4.33,0,0,0,6.09.75l.14-.11,4.23-3.57a4.66,4.66,0,0,0,.63-6.42,4.35,4.35,0,0,0-6.11-.76l-.13.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M702.49,862.09l-4.23,3.57a4.63,4.63,0,0,0-.62,6.37,4.32,4.32,0,0,0,6.05.77l.14-.12,4.25-3.57a4.63,4.63,0,0,0,.63-6.38,4.32,4.32,0,0,0-6.06-.77l-.14.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M688.4,874l-4.25,3.54a4.6,4.6,0,0,0-.65,6.34,4.28,4.28,0,0,0,6,.79l.15-.12,4.26-3.54a4.61,4.61,0,0,0,.66-6.35,4.3,4.3,0,0,0-6-.78l-.14.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M674.24,885.73l-4.26,3.5h0a4.58,4.58,0,0,0-.69,6.3,4.26,4.26,0,0,0,6,.83l.14-.11,4.28-3.51a4.58,4.58,0,0,0,.71-6.31,4.27,4.27,0,0,0-6-.83l-.13.1h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M660,897.36l-4.3,3.46h0a4.55,4.55,0,0,0-.75,6.25,4.24,4.24,0,0,0,5.93.89l.14-.11,4.32-3.46a4.53,4.53,0,0,0,.77-6.26,4.24,4.24,0,0,0-5.93-.91l-.15.11h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M645.62,908.8l-4.34,3.39h0a4.5,4.5,0,0,0-.83,6.2,4.2,4.2,0,0,0,5.86,1l.16-.12,4.38-3.39a4.54,4.54,0,0,0,.85-6.22,4.23,4.23,0,0,0-5.9-1l-.14.1h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M631.06,920l-4.39,3.3h0a4.51,4.51,0,0,0-1,6.16,4.19,4.19,0,0,0,5.82,1.06l.15-.1,4.45-3.33a4.5,4.5,0,0,0,1-6.16,4.19,4.19,0,0,0-5.82-1.07l-.16.11h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M616.36,930.9l-4.44,3.19h0a4.46,4.46,0,0,0-1,6.1,4.15,4.15,0,0,0,5.75,1.2l.15-.11,4.51-3.22a4.46,4.46,0,0,0,1.07-6.1,4.18,4.18,0,0,0-5.79-1.2l-.13.09h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M601.39,941.46l-4.53,3.09h0a4.44,4.44,0,0,0-1.19,6,4.16,4.16,0,0,0,5.73,1.31l.12-.08,4.59-3.12a4.44,4.44,0,0,0,1.2-6,4.14,4.14,0,0,0-5.72-1.33,1,1,0,0,0-.13.09h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M586.24,951.65l-4.6,3h0a4.36,4.36,0,0,0-1.31,5.92,4.1,4.1,0,0,0,5.61,1.45l.13-.08,4.68-3a4.37,4.37,0,0,0,1.36-5.93,4.11,4.11,0,0,0-5.63-1.47l-.11.07h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M570.81,961.39l-4.68,2.88h0a4.3,4.3,0,0,0-1.46,5.74,4,4,0,0,0,5.5,1.58l.11-.06,4.78-2.87a4.32,4.32,0,0,0,1.52-5.81,4.05,4.05,0,0,0-5.49-1.64l-.15.09h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M555.1,970.64l-4.78,2.66h0a4.25,4.25,0,0,0-1.64,5.66,4,4,0,0,0,5.39,1.74l.09-.05L559,978a4.26,4.26,0,0,0,1.67-5.67,4,4,0,0,0-5.39-1.79l-.12.06h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M539.17,979.31l-4.86,2.49h0a4.2,4.2,0,0,0-1.8,5.53,4,4,0,0,0,5.26,1.9l.08,0,4.95-2.5a4.18,4.18,0,0,0,1.84-5.53,4,4,0,0,0-5.23-2l-.13.07h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M522.83,987.36l-4.94,2.29h0a4.11,4.11,0,0,0-2,5.36,3.9,3.9,0,0,0,5.1,2.1l.08,0,5.06-2.3a4.13,4.13,0,0,0,2-5.37,3.91,3.91,0,0,0-5.1-2.13l-.11.05h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M506.26,994.72l-5,2h-.05A4,4,0,0,0,499,1002a3.82,3.82,0,0,0,4.91,2.29l.11,0,5.14-2.06a4.06,4.06,0,0,0,2.21-5.2,3.83,3.83,0,0,0-4.89-2.34l-.16.06h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M489.39,1001.29l-5.1,1.81h-.06a4,4,0,0,0-2.38,5,3.83,3.83,0,0,0,4.83,2.45h0l5.22-1.82a4,4,0,0,0,2.42-5,3.83,3.83,0,0,0-4.8-2.51l-.08,0h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M472.24,1007l-5.19,1.54h0a3.88,3.88,0,0,0-2.58,4.78,3.76,3.76,0,0,0,4.6,2.68h0l5.32-1.56a3.9,3.9,0,0,0,2.61-4.78,3.83,3.83,0,0,0-4.67-2.7h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M454.84,1011.85l-5.26,1.26h-.06a3.83,3.83,0,0,0-2.78,4.59,3.7,3.7,0,0,0,4.38,2.88h.05l5.39-1.24a3.83,3.83,0,0,0,2.83-4.6,3.75,3.75,0,0,0-4.43-2.88h-.12Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M437.23,1015.66l-5.33,1h-.06a3.74,3.74,0,0,0-3,4.33,3.68,3.68,0,0,0,4.18,3.1h0l5.47-1a3.77,3.77,0,0,0,3-4.34,3.67,3.67,0,0,0-4.16-3.13h-.13Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M419.42,1018.33l-5.37.6H414a3.66,3.66,0,0,0-3.18,4.07,3.62,3.62,0,0,0,3.92,3.29h0l5.5-.58a3.69,3.69,0,0,0,3.24-4.08,3.63,3.63,0,0,0-3.94-3.3h-.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M401.49,1020l-5.4.25H396a3.64,3.64,0,0,0,.3,7.27l5.53-.22a3.66,3.66,0,0,0-.28-7.32h-.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M383.49,1020.39l-5.39-.1H378a3.58,3.58,0,0,0-.14,7.16l5.53.15a3.61,3.61,0,0,0,.17-7.21Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M365.52,1019.63l-5.37-.47h-.08a3.54,3.54,0,0,0-.59,7.05l5.51.52a3.47,3.47,0,0,0,3.73-3.2h0a3.51,3.51,0,0,0-3.11-3.83h-.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M347.65,1017.63l-5.34-.85h-.07a3.38,3.38,0,0,0-3.83,2.86h0a3.45,3.45,0,0,0,2.79,4l5.47.95a3.39,3.39,0,0,0,3.87-2.84v0a3.49,3.49,0,0,0-2.81-4h-.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M330,1014.34l-5.25-1.24h-.08a3.3,3.3,0,0,0-3.95,2.49v.06a3.42,3.42,0,0,0,2.46,4.08l5.39,1.32a3.33,3.33,0,0,0,4-2.5v0a3.43,3.43,0,0,0-2.47-4.12h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M312.56,1009.72l-5.15-1.67h-.07a3.23,3.23,0,0,0-4,2.12.19.19,0,0,0,0,.07,3.38,3.38,0,0,0,2.11,4.2l5.28,1.74a3.24,3.24,0,0,0,4.08-2.1s0-.06,0-.08a3.38,3.38,0,0,0-2.11-4.24h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M295.58,1003.68l-5-2.09h-.07a3.17,3.17,0,0,0-4.13,1.72l0,.09a3.32,3.32,0,0,0,1.74,4.28l5.12,2.18a3.18,3.18,0,0,0,4.16-1.71l0-.09a3.34,3.34,0,0,0-1.75-4.32h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M279.14,996.25l-4.78-2.51h-.08a3,3,0,0,0-4.1,1.28.61.61,0,0,0-.05.12,3.22,3.22,0,0,0,1.33,4.27l4.92,2.64a3.07,3.07,0,0,0,4.16-1.28l0-.09a3.28,3.28,0,0,0-1.33-4.35h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M263.41,987.37l-4.56-2.94h-.08a3,3,0,0,0-4.08.86.41.41,0,0,0-.05.09,3.14,3.14,0,0,0,1,4.24l4.68,3.09a3,3,0,0,0,4.11-.85l.07-.11a3.18,3.18,0,0,0-1-4.31h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M248.52,977.06l-4.26-3.38-.08,0a2.87,2.87,0,0,0-4,.49l0,0a3.06,3.06,0,0,0,.51,4.19l4.38,3.53a2.87,2.87,0,0,0,4-.41l.07-.1a3.09,3.09,0,0,0-.49-4.24h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M234.75,965.27l-3.88-3.83-.07-.06a2.76,2.76,0,0,0-3.9,0l-.07.08a3,3,0,0,0,.07,4.07l4,4a2.77,2.77,0,0,0,3.92.09l.09-.09a3,3,0,0,0,0-4.14h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M222.23,952l-3.49-4.22v-.07a2.67,2.67,0,0,0-3.75-.38l-.08.08a2.87,2.87,0,0,0-.33,3.91l3.57,4.4a2.67,2.67,0,0,0,3.76.4l.06,0a2.86,2.86,0,0,0,.36-4h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M211.08,937.56,208,933v-.07a2.57,2.57,0,0,0-3.55-.74l-.1.06a2.77,2.77,0,0,0-.67,3.74l3.11,4.72a2.6,2.6,0,0,0,3.57.8l.11-.08a2.77,2.77,0,0,0,.71-3.82h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M201.35,922l-2.61-4.85v-.08a2.49,2.49,0,0,0-3.36-1.05l-.07.05a2.63,2.63,0,0,0-1,3.51l2.64,5a2.5,2.5,0,0,0,3.37,1.1l.09,0a2.69,2.69,0,0,0,1-3.57h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M193.18,905.52l-2.14-5.1v-.07a2.39,2.39,0,0,0-3.11-1.34l-.09,0a2.52,2.52,0,0,0-1.27,3.26l2.14,5.27a2.43,2.43,0,0,0,3.15,1.37l.07,0a2.57,2.57,0,0,0,1.32-3.32h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M186.63,888.27,185,883v-.07a2.33,2.33,0,0,0-2.89-1.59l0,0a2.43,2.43,0,0,0-1.53,3l1.61,5.47a2.36,2.36,0,0,0,2.91,1.63h0a2.46,2.46,0,0,0,1.57-3h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M181.86,870.42,180.79,865v-.08a2.25,2.25,0,0,0-2.61-1.81h0a2.31,2.31,0,0,0-1.76,2.7l1,5.61a2.28,2.28,0,0,0,2.63,1.86h0a2.34,2.34,0,0,0,1.8-2.74h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179,852.15l-.47-5.54v-.08a2.14,2.14,0,0,0-2.28-2h0a2.2,2.2,0,0,0-1.92,2.37l.42,5.75A2.2,2.2,0,0,0,177,854.7h0a2.22,2.22,0,0,0,2-2.41v-.09Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M178.18,833.66l.18-5.56V828a2.05,2.05,0,0,0-4.1-.17l-.24,5.75a2.08,2.08,0,0,0,4.16.19h0v-.14Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179.57,815.21l.86-5.48v-.07a2,2,0,0,0-1.62-2.32,2,2,0,0,0-2.24,1.65l-1,5.63a2.05,2.05,0,0,0,1.62,2.36,2,2,0,0,0,2.28-1.63v-.14Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M183.26,797.12l1.57-5.32v-.07a1.91,1.91,0,0,0-1.24-2.4,1.85,1.85,0,0,0-2.3,1.24v0L179.61,796a1.91,1.91,0,0,0,1.19,2.43l0,0a1.92,1.92,0,0,0,2.37-1.27h0Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1337.67,726.43s15.78-38.66-43.73-30.87-45,30.27-49.78,47.86S1214.48,780.88,1145,808s-48.87,100.95-17.67,125.4,48.23,8.23,55.52,50.54,36.22,76.67,72.35,40.8,77.19-78.28,65.7-133.89,1.52-45.08,23.93-70.6S1319.73,770,1337.67,726.43Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1324.39,830c9.44-9.57,18.64,13.4,21.06,19.22,6.19,14.58,12.63,27.67,25.71,37.65,8.09,6.19,19,10.15,29.26,7.18,36.87-10.7,37-40.31,37.86-62.49-.85-6.3,2.87-12.53,7.5-14.47,5.3-2.26,7.34-7.76,7.34-7.76s3.6,8-.83,11.75a5.2,5.2,0,0,0-1.92,4.33c.52-.09,1.06-.18,1.61-.24,11.09-1.39,0,14.47,0,14.47s10.72,58.07-38.41,81.14c-24.33,11.43-43,8.72-55.66,3.06a41.23,41.23,0,0,1-16.66-11.37,34.61,34.61,0,0,1-2.87-3.18v-.19C1318.73,884.12,1315.33,839.14,1324.39,830Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1134.76,774.93a2.24,2.24,0,0,1,4.15.44c2,7.24,6.89,19.89,17.11,24.38a1.22,1.22,0,0,0,1.21-.11,1.21,1.21,0,0,0,.55-1.08,5.29,5.29,0,0,0-1-2.82,7.14,7.14,0,0,1-.37-6.47,2.3,2.3,0,0,1,4.25-.18,12.82,12.82,0,0,0,3.5,4.68c3.83,3.16,5.66,10.22,3,16-5.53,21.5-13.81,49.93,18.47,70.71s77.74-39.25,77.74-39.25l2,54.28s-59.42,43-99.93,6.81-13.66-88.73-13.66-88.73S1121,801.18,1134.76,774.93Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1324,826.27c-9.65-2.88-37.77-8.25-64.52,16.44a16.55,16.55,0,0,0-4.78,16.49c7.19,26.45,26.14,104.59,9.57,138.39,0,0,29.28,32.29,61.27,6.27,0,0,14.36-62.48,33.11-89.91,13-18.93-20.67-71.1-29.18-83.7A10,10,0,0,0,1324,826.27Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1297.32,773.73S1283,814.13,1282,831.94a30.53,30.53,0,0,0,30.63-4.94s1.56-40.34,3.83-47.56Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1328,733.17a16.51,16.51,0,0,0-11.64-11.68c-7.6-2-18.27-3.75-25.05.18-11.49,6.7-11.49,36.56-11.49,36.56s14.69,43.26,40.46,35.2C1340,787.28,1332.6,750.3,1328,733.17Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1270.79,718.14c7.07-17,29.07-12,29.07-12s17.17,4.06,19.57,11.83c1.08,3.49-3.74,6.87-10,9.57a46.09,46.09,0,0,0-27.16,33.63l-.66,3.46S1263.72,735.16,1270.79,718.14Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1292.12,762.42s-9-20.33-17.75-11.49,7,22.19,14.77,18.92Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1362.73,1135c-.1,2.87,4.88,25.33,7.59,37.34a19.74,19.74,0,0,1-2.13,14.17l-93.81,158a21.44,21.44,0,0,0-2.47,6.15c-1.71,7.41-5.29,25.58-3.43,42.12l4.87,10.09-21-4.79-4.56-56.39,5.94-3.63a28.24,28.24,0,0,0,11.42-13.4c8.49-20.61,29.56-73.09,35-98.66,6.17-29.06,38.44-52.65,38.44-52.65l-5.66-13.4Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1229,1378.66s11.34-18,12.67-25,5-19.35,12-15.64c0,0,3.3,34,2.16,47.28s15,12.86,15,12.86a15,15,0,0,1,7.71,3.88,3.83,3.83,0,0,1-2.54,6.36,91.15,91.15,0,0,1-22.49-1.27,6.87,6.87,0,0,1-5.55-6.35l-2.33-39.12-14.3,18.06Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1306.67,1160.18s-3.31,141.29-3.76,161.37,3.17,64.54,23.29,77.82l-8.75,6.48s-11-9.29-21.63-27.18c-12-20.11-15.64-23.78-15.64-23.78l4-8.16a17.85,17.85,0,0,0,1.46-11.48c-4.34-21.06-18.84-91-22.8-106.1-4.67-17.79-5-41.54,11.24-61.44S1306.67,1160.18,1306.67,1160.18Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1288.1,1412.23a1.24,1.24,0,0,1-1.25-1.06c-.67-4.71-3.45-23.6-5.74-28.49-2.61-5.6-11.15-29.17,0-31.17,0,0,27.76,40.5,33,46s12,1.91,12,1.91a20.09,20.09,0,0,1,9.09,6.53,3.67,3.67,0,0,1-2.87,5.9l-18.67.18a13.15,13.15,0,0,1-12.32-8.28c-3.28-8.2-8.93-20.25-15.51-25.59l3.42,32.74a1.25,1.25,0,0,1-1.12,1.37h-.11Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1329.87,988.66s-4.21,13.4,2.26,35.5l40.1,140a4.36,4.36,0,0,1-2.72,5.28c-12,4.3-51.42,16.47-105.24,12.76a6.11,6.11,0,0,1-5.57-4.79c-3.55-16-15.65-70.43-18.19-81.62-9.5-42.63-20.1-88.62,26.54-116.43C1288.58,988.57,1308.62,994,1329.87,988.66Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1422.73,854.28c-1.08-2.36-.81-5.47-.57-7.92.57-5.75.52-11.36.61-17.09.24-14.81.11-29.67,1.29-44.44.25-3.18-.09-6.38.16-9.57.63-8.06,5.36-10.43,13.22-12.12,6.65-1.42,13.91-3.38,20.78-1.91,2.7.57,5.31,2.06,5.65,4.88,1.36,11.41,1,86.15-12.75,88.22-4.64.7-9.26,1.51-13.88,2.35-3.29.59-7.66,1.84-11,.73A5.72,5.72,0,0,1,1422.73,854.28Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1428.23,854.28c-1.07-2.36-.8-5.47-.56-7.92.56-5.75.51-11.36.61-17.09.24-14.81.1-29.67,1.27-44.44.26-3.18-.08-6.38.17-9.57.63-8.06,5.36-10.43,13.22-12.12,6.71-1.42,13.9-3.38,20.78-1.91,2.71.57,5.31,2.06,5.65,4.88,1.36,11.41,1,86.15-12.75,88.22-4.65.7-9.26,1.51-13.89,2.35-3.28.59-7.65,1.84-11,.73A5.67,5.67,0,0,1,1428.23,854.28Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1466,838s3-2.05,5.48-14.27,4.93-19.64,0-25.31-12.58-5.93-12.58,0,1.28,16.82.39,25.31S1460.5,852.24,1466,838Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1276.37,714a30.78,30.78,0,0,0-15.42,8.13,22.28,22.28,0,0,0-4.73,7.57l-.7,2.14-.4,2.22c-.29,1.49-.42,2.87-.66,4.31a67.46,67.46,0,0,1-14.47,31,63.45,63.45,0,0,1-12.55,11.72c-4.68,3.36-9.9,5.84-15.18,8.36s-10.6,4.79-16,7a155.88,155.88,0,0,1-16.52,5.74c11.49-2.43,22.43-6.7,33.16-11.33a88.46,88.46,0,0,0,15.59-8.27,65.66,65.66,0,0,0,13.08-11.94,67.47,67.47,0,0,0,14.44-32c.2-1.45.31-3,.53-4.37l.31-2.1.6-2a21.3,21.3,0,0,1,4.26-7.32A31.34,31.34,0,0,1,1276.37,714Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1125.27,836.51A75.47,75.47,0,0,0,1115,859.63a68,68,0,0,0-1.71,25.37,59.85,59.85,0,0,0,8.9,23.84c1.24,1.74,2.39,3.53,3.77,5.15.67.81,1.31,1.67,2,2.46l2.17,2.33c1.41,1.58,3.09,2.87,4.61,4.36a60.15,60.15,0,0,0,4.93,4A86,86,0,0,1,1123.48,908a67.91,67.91,0,0,1-5.34-11.23,61.82,61.82,0,0,1-2.87-12.07,69.75,69.75,0,0,1,1.24-24.77,82.31,82.31,0,0,1,3.58-12A81.38,81.38,0,0,1,1125.27,836.51Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1541.93,585.72h-173a28.18,28.18,0,0,0-28.18,28.18v44.4a28.18,28.18,0,0,0,28.18,28.18h53.43a3.42,3.42,0,0,1,3.11,2l22.18,49.15a3.05,3.05,0,0,0,2.68,1.79,3,3,0,0,0,2.79-1.61l26.56-49.55a3.4,3.4,0,0,1,3-1.79H1542a28.17,28.17,0,0,0,28.16-28.18V613.9A28.19,28.19,0,0,0,1542,585.72Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1507.22,634.94c0,17.55-6.9,28.56-19.93,28.56-12.6,0-19.32-11.42-19.41-28.07,0-17,7.23-28.4,20-28.4C1501.08,607,1507.22,618.8,1507.22,634.94Zm-28.91.49c-.09,13.28,3.61,20.17,9.32,20.17,6,0,9.25-7.39,9.25-20.5,0-12.69-3-20.17-9.25-20.17-5.55,0-9.38,6.8-9.32,20.49Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1552.25,634.94c0,17.55-6.9,28.56-19.92,28.56-12.6,0-19.32-11.42-19.41-28.07,0-17,7.23-28.4,20-28.4C1546.11,607,1552.25,618.8,1552.25,634.94Zm-28.91.49c-.08,13.28,3.61,20.17,9.33,20.17,6,0,9.24-7.39,9.24-20.5,0-12.69-3-20.17-9.24-20.17-5.55,0-9.43,6.8-9.33,20.49Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1425.46,661.92v-6.06l6.22-5.74c12.38-11.49,18.19-17.79,18.28-24.75,0-4.69-2.51-8.81-9.38-8.81-4.61,0-8.62,2.34-11.25,4.37l-2.87-7a26,26,0,0,1,16.18-5.41c11.64,0,17.3,7.35,17.3,15.93,0,9.21-6.63,16.65-15.77,25.14l-4.6,4v.16h21.58v8.24Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1400,622.74c0,6.92-5.61,14.36-12.53,14.36s-12.52-7.47-12.52-14.36,5.61-11.83,12.52-11.83S1400,615.82,1400,622.74Z",
    transform: "translate(-31.73 -39.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1371.92,663.77h30.58a7.4,7.4,0,0,0,7-5.14l1.65-5.15a7.4,7.4,0,0,0-4.47-9.2c-12.44-4.55-25.32-4-38.5.42a7.39,7.39,0,0,0-4.73,8.94l1.27,4.67A7.41,7.41,0,0,0,1371.92,663.77Z",
    transform: "translate(-31.73 -39.51)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon);
export default __webpack_public_path__ + "static/media/banner-icon.da5357834461e73fd37ae76ce8629eb8.svg";
export { ForwardRef as ReactComponent };